// Etiqueta UNIFICADA de estado de una cita (Sala CRM<->HCE, rebanada 4). El texto y el tono los calcula el SERVIDOR
// (packages/web/src/api/lib/estado-cita-unificado.ts, fuente única, la misma que usa el calendario del CRM): este archivo solo traduce el
// tono a clases de Tailwind. `packages/hce-chart` es un paquete aparte y no importa de `packages/web`; que los colores sean los mismos lo
// comprueba etiquetaCita.test.ts (cada tono usa la familia de color que su nombre dice, igual que packages/web/.../etiqueta-cita.ts).

export type TonoEtiqueta = 'slate' | 'amber' | 'sky' | 'violet' | 'emerald' | 'red' | 'orange' | 'zinc';

export type ClaveEtiqueta =
  | 'programada'
  | 'en-sala'
  | 'llamado'
  | 'en-consulta'
  | 'atendida'
  | 'no-asistio'
  | 'se-fue'
  | 'cancelada'
  | 'pendiente-pago';

export interface EtiquetaCita {
  readonly clave: ClaveEtiqueta;
  readonly texto: string;
  readonly tono: TonoEtiqueta;
  /** `true` = «En sala» deducida de una cita ATTENDED de hoy sin turno (no hay código de turno que mostrar). */
  readonly sinTurno: boolean;
}

/** `badge`: la etiqueta; `punto`: el punto de color de las celdas apretadas (vista mes); `borde`: realce de la fila SOLO para los estados vivos en la clínica. */
export const CLASES_TONO: Record<TonoEtiqueta, { readonly badge: string; readonly punto: string; readonly borde: string }> = {
  slate: { badge: 'bg-slate-100 text-slate-700', punto: 'bg-slate-400', borde: '' },
  amber: { badge: 'bg-amber-100 text-amber-800', punto: 'bg-amber-500', borde: 'border-l-4 border-l-amber-400 bg-amber-50/50' },
  sky: { badge: 'bg-sky-100 text-sky-800', punto: 'bg-sky-500', borde: 'border-l-4 border-l-sky-400 bg-sky-50/50' },
  violet: { badge: 'bg-violet-100 text-violet-800', punto: 'bg-violet-500', borde: 'border-l-4 border-l-violet-400 bg-violet-50/50' },
  emerald: { badge: 'bg-emerald-100 text-emerald-800', punto: 'bg-emerald-500', borde: '' },
  red: { badge: 'bg-red-100 text-red-700', punto: 'bg-red-500', borde: '' },
  orange: { badge: 'bg-orange-100 text-orange-800', punto: 'bg-orange-500', borde: '' },
  zinc: { badge: 'bg-zinc-200 text-zinc-600', punto: 'bg-zinc-400', borde: '' },
};

/**
 * Clases de una etiqueta, con respaldo NEUTRO (slate) si la etiqueta falta o trae un tono que este bundle no conoce: un servidor más viejo
 * (o más nuevo) que el bundle no debe dejar el Dashboard en blanco por un `undefined.tono`.
 */
export function clasesDeEtiqueta(etiqueta: { readonly tono?: string } | null | undefined): { readonly badge: string; readonly punto: string; readonly borde: string } {
  const tono = etiqueta?.tono;
  return tono !== undefined && Object.prototype.hasOwnProperty.call(CLASES_TONO, tono) ? CLASES_TONO[tono as TonoEtiqueta] : CLASES_TONO.slate;
}
